module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Nicholas Wolterstorff\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v(" "), _c('B', [_vm._v("Nicholas Wolterstorff")]), _vm._v(" is Noah Porter Professor Emeritus of Philosophical Theology at Yale University. Before going to Yale he taught philosophy at Calvin College in Grand Rapids, Michigan, for thirty years. His other books include "), _c('I', [_vm._v("Justice in Love, Educating for Shalom, The God We Worship")]), _vm._v(", and "), _c('I', [_vm._v("Lament for a Son")]), _vm._v(".")], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/NqPa48/tc-custom/9781467452724.jpg?1708515322956",
      "alt": "This image is the cover for the book In This World of Wonders"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("In This World of Wonders\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("World-renowned Christian philosopher. Beloved professor. Author of the classic "), _c('i', [_vm._v("Lament for a Son")]), _vm._v(". Nicholas Wolterstorff is all of these and more. His memoir, "), _c('i', [_vm._v("In This World of Wonders, ")]), _vm._v("opens a remarkable new window into the life and thought of this remarkable man.")]), _c('p', [_vm._v("Written not as a complete life story but as a series of vignettes, Wolterstorff’s memoir moves from his humble beginnings in a tiny Minnesota village to his education at Calvin College and Harvard University, to his career of teaching philosophy and writing books, to the experiences that prompted some of his writing—particularly his witnessing South African apartheid and Palestinian oppression firsthand.")]), _c('p', [_c('i', [_vm._v("In This World of Wonders ")]), _vm._v("is the story of a thoughtful and grateful Christian whose life has been shaped by many loves—love of philosophy, love of family, love of art and architecture, love of nature and gardening, and more. It’s a lovely, wonderful story.")]), _vm._v(" "), _c('p')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    William B. Eerdmans Publishing Company\n   ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0